import React, { useEffect, useState } from "react";

import dayjs from "dayjs";
import { Box, Typography } from "@mui/material";

//TODO
export const dayNames = ["Po", "Út", "St", "Čt", "Pá", "So", "Ne"];

export const monthNames = [
    "Leden",
    "Únor",
    "Březen",
    "Duben",
    "Květen",
    "Červen",
    "Červenec",
    "Srpen",
    "Září",
    "Říjen",
    "Listopad",
    "Prosinec",
];

const MonthDay = ({ children, onClick, day, dayNumber }) => {
    return (
        <Box
            sx={(theme) => ({
                paddingTop: "100%",
                cursor: onClick ? "pointer" : "default",
                "& > div": {
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    fontWeight: 700,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                },
                "& > .MonthDayAction": {
                    display: "none",
                },
                "&:hover > .MonthDayAction": {
                    display: "block",
                },
            })}
            onClick={() => onClick && onClick(day)}>
            <Typography component="div">{dayNumber}</Typography>
            {children}
        </Box>
    );
};

const _defaultRenderDay = (day, onClick) => {
    return <MonthDay day={day.date} dayNumber={day.dayNumber} onClick={onClick} />;
};

export const MonthCalendar = ({
    month = 11,
    year = 2021,
    data,
    onClick,
    renderDay,
    color,
    minThreshold,
    maxThreshold,
    valueKey,
    ...props
}) => {
    const [days, setDays] = useState([]);
    //prepare grid
    useEffect(() => {
        let ds = [];
        let m = dayjs().year(year).month(month).startOf("month");
        if (m.isoWeekday() !== 1) {
            m = m.isoWeekday(1);
            let i = 0;
            while (m.month() !== month && i < 8) {
                ds.push({ padding: true });
                m = m.add(1, "day");
                i++;
            }
        }

        let i = 0;
        while (m.month() === month && i < 32) {
            ds.push({ date: m.format("YYYY-MM-DD"), dayNumber: m.get("date") });
            m = m.add(1, "day");
            i++;
        }

        setDays(ds);
    }, [month, year]);

    /*
    const daysData = useMemo(() => {
        let key = valueKey || "value";
        let c = color || theme.palette.primary.main;

        if (!data) {
            return {};
        }
        let daysData = {};
        for (let date in data) {
            let val = data[date] && data[date][key];
            let value = {
                ...data[date],
            };
            if (!isNaN(val)) {
                if (isNaN(maxThreshold) || val > maxThreshold) {
                    value.color = c;
                } else if ((isNaN(minThreshold) || val > minThreshold) && maxThreshold) {
                    value.color = emphasize(c, (1 - val / maxThreshold) * 0.8);
                }
            }

            daysData[date] = value;
        }
        return daysData;
    }, [valueKey, color, theme, data, minThreshold, maxThreshold]);
    */

    const render = renderDay || _defaultRenderDay;

    return (
        <Box
            sx={{
                width: "100%",
                display: "grid",
                gridTemplateColumns: "repeat(7, 1fr)",
                gridAutoRows: "min() 1fr",
                gap: "4px 4px",
                "& > div": {
                    width: "100%",
                    position: "relative",
                },
            }}>
            {dayNames.map((name, key) => (
                <Box
                    sx={(theme) => ({
                        paddingTop: theme.spacing(1),
                        paddingBottom: theme.spacing(1),
                        textAlign: "center",
                        color:
                            (theme.palette.onSurfaceVariant &&
                                theme.palette.onSurfaceVariant.main) ||
                            theme.palette.grey["500"],
                        fontWeight: 700,
                    })}
                    key={key}>
                    <Typography>{name}</Typography>
                </Box>
            ))}
            {days.map((d, key) => {
                if (d.padding) {
                    return <Box key={key} sx={{ background: "none" }} />;
                }

                /*
                let { color, ...data } = daysData[d.date] || {};
                if (!color) {
                    color = theme.palette.surfaceContainerHighest.main;
                }
                */

                return <React.Fragment key={key}>{render(d, onClick)}</React.Fragment>;
            })}
        </Box>
    );
};

export const WeekCalendar = ({
    week = 1,
    year = 2021,
    data,
    onClick,
    renderDay,
    color,
    minThreshold,
    maxThreshold,
    valueKey,
    onDayClick,
    ...props
}) => {
    const dayNames = ["Po", "Út", "St", "Čt", "Pá", "So", "Ne"];
    const d = dayjs().year(year).isoWeek(week).startOf("isoWeek");

    return (
        <Box
            sx={{
                width: "100%",
                display: "grid",
                gridTemplateColumns: "repeat(7, 1fr)",
                gridAutoRows: "min() 1fr",
                gap: "4px 4px",
                "& > div": {
                    width: "100%",
                    position: "relative",
                },
            }}>
            {dayNames.map((name, key) => (
                <Box
                    sx={(theme) => ({
                        paddingTop: theme.spacing(1),
                        paddingBottom: theme.spacing(1),
                        textAlign: "center",
                        color:
                            (theme.palette.onSurfaceVariant &&
                                theme.palette.onSurfaceVariant.main) ||
                            theme.palette.grey["500"],
                        fontWeight: 700,
                        cursor: onDayClick ? "pointer" : "default",
                    })}
                    onClick={() => onDayClick?.(d.add(key, "day").format("YYYY-MM-DD"))}
                    key={key}>
                    <Typography sx={{ fontWeight: 700, display: "block", mb: 1 }}>
                        {name}
                    </Typography>
                    <Typography sx={{ fontWeight: 400, display: "block" }}>
                        {d.add(key, "day").format("DD.MM.")}
                    </Typography>
                </Box>
            ))}
        </Box>
    );
};

export const DayCalendar = ({
    date = "2021-12-31",
    data,
    onClick,
    renderDay,
    color,
    minThreshold,
    maxThreshold,
    valueKey,
    ...props
}) => {
    return null;
};

/*
const createClasses = makeStyles((theme) => ({
    grid: {
        width: "100%",
        display: "grid",
        gridTemplateColumns: "repeat(7, 1fr)",
        gridAutoRows: "min() 1fr",
        gap: "4px 4px",
        "& > div": {
            width: "100%",
            position: "relative",
        },
    },
    dayName: {
        paddingTop: 0,
        paddingBottom: theme.spacing(1),
        textAlign: "center",
        color: "#888",
        fontWeight: 700,
    },
    padding: {
        background: "none",
    },
    day: {
        backgroundColor: "#F6F6F6",
        paddingTop: "100%",
        cursor: "default",
        "& > div": {
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            fontWeight: 700,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
        },
        "& > .MonthDayAction": {
            display: "none",
        },
        "&:hover > .MonthDayAction": {
            display: "block",
        },
    },
    weekDay: {
        overflow: "hidden",
        position: "relative",
    },
    weekDayHeader: {
        position: "relative",
        backgroundColor: "#F6F6F6",
        paddingTop: "100%",
        cursor: "pointer",
        "& > div": {
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
        },
        "& > .MonthDayAction": {
            display: "none",
        },
        "&:hover > .MonthDayAction": {
            display: "block",
        },
    },
    weekDayNumber: {
        fontWeight: 700,
        color: "#3B3B3B",
    },
    dayClickable: {
        cursor: "pointer",
    },
    dayContainer: {
        minHeight: 250,
    },
    dayAction: {
        paddingTop: 24,
        paddingBottom: 24,
        fontWeight: 700,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
    },
    monthDayAction: {
        position: "absolute",
        right: 0,
        bottom: 0,
    },
}));

//TODO

export const MonthDay = ({ children, onClick, color, day, dayNumber, onAction, actionIcon, actionTitle }) => {
    const classes = createClasses();
    const theme = useTheme();

    return (
        <div
            className={classnames(classes.day, !!onClick && classes.dayClickable)}
            onClick={() => onClick && onClick(day)}
            style={!!color ? { color: theme.palette.getContrastText(color), backgroundColor: color } : null}>
            <div>{dayNumber}</div>
            {children}
            {!!onAction && (
                <IconButton
                    className={classnames(classes.monthDayAction, "MonthDayAction")}
                    title={actionTitle || null}
                    onClick={(e) => {
                        e.stopPropagation();
                        onAction && onAction(day);
                    }}
                    size="small"
                    style={!!color ? { color: theme.palette.getContrastText(color) } : null}>
                    {actionIcon || null}
                </IconButton>
            )}
        </div>
    );
};

const _defaultRenderDay = (day, onClick) => {
    return <MonthDay key={day.date} day={day.date} dayNumber={day.dayNumber} onClick={onClick} />;
};

export const MonthCalendar = ({ month = 11, year = 2021, onClick, renderDay, ...props }) => {
    const classes = createClasses();
    const [days, setDays] = useState([]);

    //const baseColor = theme.palette.primary.main;

    //prepare grid
    useEffect(() => {
        let ds = [];
        let m = moment();
        m.year(year);
        m.month(month);
        m = m.startOf("month");

        if (!month) {
            month = m.month();
        }

        //TODO start of week
        if (m.isoWeekday() != 1) {
            m.isoWeekday(1);
            while (m.month() != month) {
                ds.push({ padding: true });
                m = m.add("day", 1);
            }
        }

        while (m.month() == month) {
            ds.push({ date: m.format("YYYY-MM-DD"), dayNumber: m.get("date") });
            m = m.add("day", 1);
        }

        setDays(ds);
    }, [month, year]);

    const render = renderDay || _defaultRenderDay;

    return (
        <div className={classes.grid}>
            {dayNames.map((name, key) => (
                <div className={classes.dayName} key={key}>
                    {name}
                </div>
            ))}
            {days.map((d, key) => {
                if (d.padding) {
                    return <div key={key} className={classes.padding} />;
                }

                return <React.Fragment key={key}>{render(d, onClick)}</React.Fragment>;
            })}
        </div>
    );
};

export const WeekCalendar = ({ week = 0, year = 2021, onClick, renderDay, onAction, actionIcon, actionTitle }) => {
    const classes = createClasses();

    const m = moment().utc();
    m.year(year);
    m.isoWeek(week);
    m.startOf("isoWeek");

    const render = renderDay || (() => null);

    return (
        <div className={classes.grid}>
            {dayNames.map((name, key) => {
                let md = moment(m).utc().add("days", key);
                const day = md.format("YYYY-MM-DD");
                return (
                    <div key={key} className={classes.weekDay}>
                        <div className={classes.weekDayHeader} onClick={() => !!onClick && onClick(day)}>
                            <div>
                                <div className={classes.weekDayNumber}>{name}</div>
                                <Typography component="div" variant="body2">
                                    {md.format("DD.MM.")}
                                </Typography>
                            </div>
                            {!!onAction && (
                                <IconButton
                                    className={classnames(classes.monthDayAction, "MonthDayAction")}
                                    title={actionTitle || null}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        onAction && onAction(day);
                                    }}
                                    size="small">
                                    {actionIcon || null}
                                </IconButton>
                            )}
                        </div>
                        <div>{renderDay(day)}</div>
                    </div>
                );
            })}
        </div>
    );
};

export const DayCalendar = ({ date, renderDay }) => {
    const classes = createClasses();
    const render = renderDay || (() => null);

    const md = moment(date);

    return <div className={classes.dayContainer}>{renderDay(md.format("YYYY-MM-DD"))}</div>;
};

export const DayCalendarAction = ({ icon, onClick, title }) => {
    const classes = createClasses();

    return (
        <div className={classes.dayAction}>
            <IconButton onClick={onClick} title={title}>
                {icon || null}
            </IconButton>
        </div>
    );
};
*/
